module.exports = __webpack_public_path__ + "img/discover-pill.78b32c98.svg";